import React from 'react'
import { Loader } from 'components/UIElements'

/**
 * Non-null placeholder while async v3 route callbacks resolve.
 * Required when v7_startTransition is enabled — returning null keeps the
 * previous route visible until the next route renders real content.
 */
export default function RouteLoadFallback() {
  return (
    <div
      className='route-load-fallback flexed column center-justified center-aligned'
      style={{ minHeight: '60vh' }}
      aria-busy='true'
      aria-live='polite'>
      <Loader size={60} />
    </div>
  )
}
